/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */


/**
 * The type of the credential
 * @export
 */
export const CredentialType = {
    PublicKey: 'public-key',
    Password: 'password',
    Totp: 'totp'
} as const;
export type CredentialType = typeof CredentialType[keyof typeof CredentialType];


export function CredentialTypeFromJSON(json: any): CredentialType {
    return CredentialTypeFromJSONTyped(json, false);
}

export function CredentialTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CredentialType {
    return json as CredentialType;
}

export function CredentialTypeToJSON(value?: CredentialType | null): any {
    return value as any;
}

